import { createContext } from "react";

export interface DocumentEditorOpenOptions {
  docId: number;
  onClosed?: () => void;
  onDeleted?: () => void;
}

export interface DocumentEditorContextValue {
  open: (options: DocumentEditorOpenOptions) => void;
  close: () => void;
  isOpen: boolean;
  docId: number | null;
  /** Nach Löschen im Editor – ruft optionales onDeleted aus open() auf. */
  notifyDeleted: () => void;
  /** Wenn der Editor auf ein anderes Dokument wechselt (z. B. Kette). */
  changeDocId: (docId: number) => void;
}

export const DocumentEditorContext = createContext<DocumentEditorContextValue | null>(null);
